import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { formatCurrency } from '../../utils/formatNumber';


export default class GridAmountCell extends Component {
    //props: value, id, field
    render() {
        const value = this.props.value;
        const formattedAmount = formatCurrency(value, this.props.row.currency);
        const baseStyle = this.props.styles;
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {formattedAmount}
            </TableCell>
        );
    }
}
